import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList({ page, size, topUserId, userId, channelId, channelUserId, type, startTime, endTime, positionId, billType, coin, bizId, balanceType }) {
    const safeChannelId =
      channelId === undefined || channelId === null || channelId === "undefined"
        ? ""
        : channelId;
    return http.get({
      url: `/ta/admin/channel/bill/list?page=${page}&size=${size}&type=${type}&topUserId=${topUserId || ''}&userId=${userId || ''}&channelUserId=${channelUserId || ''}&channelId=${safeChannelId}&startTime=${startTime || ''}&endTime=${endTime || ''}&positionId=${positionId || ''}&billType=${billType || ''}&coin=${coin || ''}&bizId=${bizId || ''}&balanceType=${balanceType || ''}`,
    });
  },
  //更新后的查询所有用户信息
  exportExcel({ page, size, topUserId, userId, channelId, channelUserId, type, startTime, endTime, positionId, billType, coin, bizId, balanceType }) {
    const safeChannelId =
      channelId === undefined || channelId === null || channelId === "undefined"
        ? ""
        : channelId;
    return http.get({
      url: `/ta/admin/channel/bill/list/excel?page=${page}&size=${size}&type=${type}&topUserId=${topUserId || ''}&userId=${userId || ''}&channelUserId=${channelUserId || ''}&channelId=${safeChannelId}&startTime=${startTime || ''}&endTime=${endTime || ''}&positionId=${positionId || ''}&billType=${billType || ''}&coin=${coin || ''}&bizId=${bizId || ''}&balanceType=${balanceType || ''}`,
      responseType: 'blob',
    });
  },
  // 添加备注
  addRemark({ channelId, userId, remark }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remark=${remark}&userId=${userId}`,
    });
  },

  //钱包资产明细
  getDetail({ userId, coin }) {
    return http.get({
      url: `/channel/spot/detail?userId=${userId}&coin=${coin}`,
    });
  },
  //获取币种列表
  getCoinList(data = {}) {
    const type = data.type || "CONTRACT";
    return http.get({
      url: `/ta/admin/tenant/coin/list?type=${type}`
    })
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    });
  },
};
